var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCookbookinline = function SvgCookbookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.678 2.303a3.03 3.03 0 0 1 2.644 0l7.316 3.555a2.365 2.365 0 0 1 0 4.284l-7.316 3.555a3.03 3.03 0 0 1-2.644 0l-7.316-3.555a2.365 2.365 0 0 1 0-4.284zm1.763 1.714a1.01 1.01 0 0 0-.882 0L4.244 7.572a.473.473 0 0 0 0 .856l7.315 3.555c.278.135.604.135.882 0l7.315-3.555a.473.473 0 0 0 0-.856z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.106 16.817a1 1 0 0 1 1.341-.447l8.106 4.053a1 1 0 0 0 .894 0l8.106-4.053a1 1 0 1 1 .894 1.789l-8.105 4.053a3 3 0 0 1-2.684 0l-8.105-4.053a1 1 0 0 1-.447-1.342"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.447 12.106a1 1 0 1 0-.894 1.789l8.106 4.052a3 3 0 0 0 2.683 0l8.105-4.052a1 1 0 1 0-.894-1.79l-8.106 4.054a1 1 0 0 1-.894 0z"
  })));
};
export default SvgCookbookinline;